module.exports = __webpack_public_path__ + "static/img/title-charging-dl.1e4bfd68.png";